import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import manualTypeAtom from "../atoms/manualTypeAtom";



function ManualCard( { image, title, type }) {
    const [ manualType, setManualType ] = useRecoilState(manualTypeAtom);
    const navigate = useNavigate();

    function navigateToManual(type) {
        try {
            if(type === 'faq') {
                navigate('/faqs')
            } else {
                setManualType(type);
                navigate('/make_selector')
            }
        } catch (error) {
            console.log(error)
        }
    }

    return(
        <div className='rounded-xl px-4 py-6 bg-customTwo flex gap-4 shadow-lg mb-8'>
            <div className="w-1/2">
                <img src={image} width={200} />
            </div>
            <div className="w-1/2 flex flex-col justify-between py-2">
                <div className="text-md font-semibold">{title}</div>
                <div className="text-xs text-customThree font-semibold">View The Manual In The PDF Format For The Vehicle.</div>
                <div className="text-sm font-semibold text-customOne cursor-pointer" onClick={() =>  navigateToManual(type)}>
                    {
                        type === 'faq' ?
                        'View FAQs/Queries'
                        :
                        'View Manual'
                    }
                </div>
            </div>
        </div>
    )
}
export default ManualCard;